module.exports = __webpack_public_path__ + "img/advance_upload.e90547e5.svg";